import CurrencyCode from "../dto/CurrencyCodeEnum";
import Customer from "../dto/customer/Customer";
import ICustomer from "../dto/customer/ICustomer";
import ICustomerModel from "../model/applicationForm/ICustomer";
import Cohabitation from "@/module/main/dto/customer/CohabitationEnum";
import Education from "@/module/main/dto/customer/EducationEnum";
import HousingTenure from "@/module/main/dto/customer/HousingTenureEnum";
import { EnumUtil } from "@/app";
import CustomerBaseMapper from "@/module/main/service/CustomerBaseMapper";

class CustomerMapperV2 extends CustomerBaseMapper {

    public getCustomer(customer: ICustomerModel, currencyCode: CurrencyCode): ICustomer {

        return new Customer(
            customer.block1.identificationNumberRaw || undefined,
            customer.block1.phone || undefined,
            customer.block1.email || undefined,
            customer.block1.firstName || undefined,
            customer.block1.lastName || undefined,
            this.getIncome(customer, currencyCode),
            this.createAmount(customer.block2Income.householdIncome, currencyCode),
            this.createAmount(customer.block2Income.expenses, currencyCode),
            EnumUtil.getEnumValue(Cohabitation, customer.block2Others.cohabitation),
            EnumUtil.getEnumValue(Education, customer.block2Others.education),
            EnumUtil.getEnumValue(HousingTenure, customer.block2Others.housingTenure),
            customer.block2Others.housingZipCode || undefined,
            customer.block2Others.birthplace || undefined,
            this.stringToNumber(customer.block2Others.childrenCount) || undefined,
            customer.block2Others.nationality || undefined,
            this.getPoliticallyExposed(customer),
            this.getAddresses(customer),
            this.getBankAccount(customer, currencyCode),
            this.getPrimaryPersonalDocument(customer),
            this.getSecondaryPersonalDocument(customer)
        );
    }
}

export default new CustomerMapperV2();
